import React from 'react';
import './DataLibraryClient.scss';
import { getLibrary } from '../../../MainVIew/Library/libraryslice';


const DataLibraryClient = (props) => {
    const {dispatch} = props;
const onGetLibrary = () => {
    dispatch(getLibrary());
}


  const  renderTable = () => {
        let  data =  props.libraryData.libraryContent;


        return (
            data.map(item => {
                console.log(item);
                return(
                    <tr key={item.titles}>
                        <td >{item.writers}</td>
                        <td >{item.titles}</td>
                        <td ><button className='smallbtnContent' ></button></td>
                        <td>{item.category}</td>
                        <td>{item.year}</td>
                        <td><button className='btnFavorites'></button>{item.score}</td>
                       
                    </tr>
                    )
                })
            )    
       }


       return (
        <div className='DataLibraryClient'>
            <button className='updateButton' onClick={onGetLibrary}></button>
            <div className='sorting'>
                <p>Сортировать</p>
                <p>по рейтингу</p>
                 <p>по году</p>
            </div>
            <div>
            <table>
                            <thead>
                                <tr>
                                    <th className='writers'>Автор</th>
                                    <th className='titles'>Наименование</th>
                                    <th className='btnCell'></th>
                                    <th className='category'>Категория</th>
                                    
                                    <th className='year'>Год</th>
                                    <th className='rank'>Рейтинг</th>
                                   
                                </tr>
                                
                            </thead>
                            <tbody>
                            
                                {renderTable()}
                            
                            </tbody>
                        </table>
            </div>
           
        </div>
       )
        

    
}
export default DataLibraryClient;